/**
 * Floating Review Button
 * Shows on scroll, hides when reviews are in view,
 * smooth-scrolls to the reviews section on click.
 */

(function () {
  var btn = document.getElementById('floatingReviewBtn');
  if (!btn) return;

  var trigger = btn.querySelector('.floating-review-btn__trigger');
  var threshold = parseInt(btn.dataset.scrollThreshold) || 150;
  var targetTag = btn.dataset.targetSection || 'product-reviews';
  var reviewsEl = null;
  var visible = false;
  var atReviews = false;

  // Find the reviews section — look for the <product-reviews> element or
  // a Shopify section wrapper whose id contains the target tag
  function findReviewsSection() {
    // Direct custom element
    var el = document.querySelector('product-reviews');
    if (el) return el;
    // Shopify section wrapper
    var sections = document.querySelectorAll('[id*="' + targetTag + '"]');
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].id.indexOf('shopify-section') > -1 || sections[i].classList.contains('product-reviews')) {
        return sections[i];
      }
    }
    return null;
  }

  reviewsEl = findReviewsSection();

  // Scroll handling (rAF throttled)
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var scrollY = window.scrollY || window.pageYOffset;

      // Show/hide based on scroll threshold
      if (scrollY > threshold) {
        if (!visible) {
          btn.classList.add('visible');
          visible = true;
        }
      } else {
        if (visible) {
          btn.classList.remove('visible');
          visible = false;
        }
      }

      // Hide when reviews section is in view
      if (reviewsEl) {
        var rect = reviewsEl.getBoundingClientRect();
        var inView = rect.top < window.innerHeight && rect.bottom > 0;
        if (inView && !atReviews) {
          btn.classList.add('at-reviews');
          atReviews = true;
        } else if (!inView && atReviews) {
          btn.classList.remove('at-reviews');
          atReviews = false;
        }
      }

      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // initial check

  // Click → smooth scroll to reviews
  if (trigger) {
    trigger.addEventListener('click', function () {
      // Re-find in case it was lazy loaded
      if (!reviewsEl) reviewsEl = findReviewsSection();
      if (!reviewsEl) return;

      var navbarHeight = 0;
      var navbar = document.querySelector('.pill-navbar') || document.querySelector('sticky-header');
      if (navbar) navbarHeight = navbar.offsetHeight + 16;

      var top = reviewsEl.getBoundingClientRect().top + window.scrollY - navbarHeight;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }
})();
